// extracted by mini-css-extract-plugin
export default {"type":"Type_type__WTqPw","text":"Type_text__ZATD3"};